import { startLoadingCategory } from './start-loading-category';
import { stopLoadingCategory } from './stop-loading-category';
import { setIsCategoryLoaded } from './set-is-category-loaded';
import fetchPosts from './fetch-posts';

const finishLoading = (dispatch, categoryId) => {
  dispatch(stopLoadingCategory(categoryId));
  dispatch(setIsCategoryLoaded(categoryId, true));
};

export const fetchCategoryPosts = ({ categoryId, page, pageSize }) => dispatch => {
  dispatch(startLoadingCategory(categoryId));
  const promise = dispatch(fetchPosts({ categoryId, page, pageSize }));

  return promise
    .then(() => finishLoading(dispatch, categoryId))
    .catch(() => finishLoading(dispatch, categoryId))
    .then(() => promise);
};



// WEBPACK FOOTER //
// ./app/actions/fetch-category-posts.js